import {
  Typography,
  List,
  ListItem,
  ListItemSecondaryAction,
  Switch,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Indicator } from "../../types";

interface Props {
  masks: Indicator[];
}

export function SettingsMasksSelection(props: Props) {
  const { masks } = props;
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const disabledMasks = params.getAll("masks");

  function onToggleMask(mask: Indicator) {
    const clone = new URLSearchParams(params);
    const found = disabledMasks.find((search) => mask.id.toString() === search);

    if (!found) {
      clone.append("masks", mask.id.toString());
    } else {
      const [firstValue, ...rest] = disabledMasks.filter(
        (filteredMask) => mask.id.toString() !== filteredMask
      );
      clone.delete("masks");
      if (firstValue) {
        clone.set("masks", firstValue);
        (rest || []).forEach((maskId) => clone.append("masks", maskId));
      }
    }
    setParams(clone);
  }

  return (
    <>
      <Typography variant="subtitle2" color="white">
        {t("label.areaLayers")}
      </Typography>
      <List>
        {masks.map((mask) => (
          <ListItem key={`baselayer-option-${mask.id}`}>
            <ListItemText color="white">{mask.title}</ListItemText>
            <ListItemSecondaryAction>
              <Switch
                edge="end"
                checked={disabledMasks.indexOf(mask.id.toString()) === -1}
                onClick={() => onToggleMask(mask)}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </>
  );
}
